import React, { useState, useEffect } from "react";
import NavigationBar from "../ReusableComp/NavigationBar";
import { MarketingHeadFlow } from "../ReusableComp/NavBarLeft";
import { Table, Container, Row, Col } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import { getMhSitesData } from "../../Redux/actions/actions"; // Update the import path based on your project structure
const MarketingHeadSites = () => {
    const dispatch = useDispatch();
    const allMHsites = useSelector((state) => state.allMHsites);
    const loading_flag = useSelector((state) => state.loading_flag);
    const [selectedMS, setSelectedMS] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1)
    const [siteName, setSiteName] = useState("");
    const [piDataFlag,setPiDataFlag]=useState(false);
    const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        dispatch(getMhSitesData());
        setLoading(true)
    }, [dispatch]);
    useEffect(() => {
        // Update filteredData when allMHsites changes
        setFilteredData(allMHsites);
        if (allMHsites) {
            setLoading(false)
        }
    }, [allMHsites]);
    const handleSearchData = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchText(searchText);
        // Filter the data based on the site name
        const filteredData = allMHsites.filter((siteData) => {
            return siteData.site_name.toLowerCase().includes(searchText);
        });
        // Update the filtered data
        setFilteredData(filteredData);
    };
    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new();
        const sheetData = [];
        // Prepare the header row with the desired headings
        const headerRow = ['Site Name', 'Site Address', 'Phone Number', 'Total Principal Investigators'];
        sheetData.push(headerRow);
        // Prepare the data rows
        filteredData.forEach((siteData) => {
            const rowData = [
                siteData.site_name,
                siteData.site_address,
                siteData.phone_number,
                siteData.pi_count, // You need to populate this field with the total PIs
            ];
            sheetData.push(rowData);
        });
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        // Convert the workbook to an Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // Save the Blob as an Excel file
        saveAs(blob, 'Site_Details.xlsx');
    };
    const handleBackClick = () => {
        setCurrentPage(1)
    }
    const handleSubjectData = (data, siteName) => {
        setSelectedMS(data.list_of_pi)
        if (data.list_of_pi.length === 0) {
            setPiDataFlag(false);
          } else if (data.list_of_pi.length === 1) {
            const i = data.list_of_pi[0];
            const allValuesAreNull = Object.values(i).every(value => value === null); 
            if (allValuesAreNull) {
              setPiDataFlag(false);
            } else {
              setPiDataFlag(true);
            }
          } else {
            setPiDataFlag(true);
          }
          
        setSiteName(siteName);
        setCurrentPage(2)
    }

    const handleAscending = () => {
        setAsC(true);
        setDesc(false);
      
        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
          const nameA = a.site_name || ''; 
          const nameB = b.site_name || ''; 
          return nameA.localeCompare(nameB);
        });
      
        
        setFilteredData(sortedData);
      };
      
      const handleDescending = () => {
        setDesc(true);
        setAsC(false);
      
        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
          const nameA = a.site_name || ''; 
          const nameB = b.site_name || '';
      
          return nameB.localeCompare(nameA);
        });
       
      
        setFilteredData(sortedData);
      };

    function SiteTable({ data }) {
        if (!data) {
            return null;
        }
        return (
            <>
                {currentPage === 1 && <Table bordered size="sm" className='pitable mssubjlistmbl'>
                    <thead className="sticky_table_header">
                        <tr>
                        <th className="sticky-header">
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span className="site-address-header" style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Site Name</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                            </th>
                            <th className="site-address-header">Site Address</th>
                            <th>Phone Number
                            </th>
                            <th>Total Principal Investigators
                            </th>
                            <th>Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((siteData) => (
                            <tr key={siteData.site_id} className="text_left_table">
                                <td className="site-address-cell">{siteData.site_name}</td>
                                <td className="site-address-cell">{siteData.site_address}</td>
                                <td>{siteData.phone_number}</td>
                                <td>{siteData.pi_count}</td>
                                <td className='viewbtnstyl'>
                                    <button className="gray_btn px-3" onClick={() => handleSubjectData(siteData, siteData.site_name)}>
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                }
            </>
        );
    }
    return (
        <div>
            <NavigationBar studyDropdwn={true} title={"Sites Information"} />
            {/* <MarketingHeadFlow /> */}
            {currentPage === 1 &&
                <div className="main_body main_body_site text-center">
                    <Container fluid className='pitable_container'>
                        <Row className='searchbar'>
                            <Col className='searchFiled gap-3'>
                                <label htmlFor="" />
                                <input type="text" value={searchText} onChange={handleSearchData} placeholder='Search with Site Name' />
                                <div className=" ">
                                    <button
                                        className="btn btn-success"
                                        onClick={exportToExcel}
                                        style={{height:"42px"}}
                                    >
                                        Download XLS
                                        <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <div>
                            {loading ? (
                                <div className=''>
                                    <img
                                        className="atrium_loader"
                                        src="/images/circle-effect-loading.gif"
                                        alt="Loader"
                                    />
                                </div>
                            ) : (
                                <div className=''>
                                    <SiteTable data={filteredData} />
                                </div>
                            )}
                        </div>
                    </Container>
                </div>
            }
            {currentPage === 2 &&
                <div className="main_body main_body_site text-center">
                    <Container fluid className='py-3 page_two_styl'>
                        <Row className='d-flex justify-content-between'>
                            <Col><button className="white_btn white_btn_back" onClick={handleBackClick}>{'< '}Back</button> </Col>
                        </Row>
                        <Container fluid className='py-3 '>
                            <Row className='viewPage' style={{ maxHeight: "71vh", overflowY: "auto",overflowX:"hidden" }}>
                                <div style={{ marginTop: "24px", marginLeft: "25px", width: "85vw" }}>
                                    <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Site Name: {siteName && siteName}</p>
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", marginBottom: "32px", width: "85vw" }}></div>
                                {piDataFlag ? (
                                   selectedMS?.map((i) => {
                                    return (
                                        <div className='piViewStudy' style={{ width: "85vw", backgroundColor: "#eaeaea87" }}>
                                            <h5 style={{ marginLeft: "25px" }}>Principal Investigator : {i.pi_name}</h5>
                                            <div style={{ border: "1px dotted #E1E5E7", }}></div>
                                            <Row className='mappringCard' style={{ padding: "12px" }}>
                                                <Col className='mappingCardItem'>
                                                    <p>{i.pi_address}</p>
                                                    <p style={{ textAlign: "start" }}>{i.pi_state}, {i.pi_country}</p>
                                                    <p >{i.pin_code}</p>
                                                </Col>
                                                <Col className='mappingCardItem'>
                                                    <p>{i.pi_gender}</p>
                                                    <p>{i.pi_email}</p>
                                                    <p style={{ textAlign: "start" }}>Principal Investigator</p>
                                                </Col>
                                                <Col className='mappingCardItem' style={{ alignItems: "center", justifyContent: "center" }}>
                                                    <p>{i.pi_contact_number}
                                                        <img className='' src="./images/icons/Telephone.svg" alt="Telephone" style={{ marginLeft: "10px" }} />
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>
                                    )
                                })
                                ) : (
                                    
                                    <>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',marginBottom:"40px"}}>
                                            <img src="./images/no_subjects.svg" alt="Telephone" />
                                            <h6>No PI is found in this site</h6>
                                            </div>      
                                            </>
                                )}

                            </Row>
                        </Container>
                    </Container>
                </div>
            }
        </div>
    );
};
export default MarketingHeadSites;